export const QualificationDropDownSettings = {
    singleSelection: false,
    text: 'Fachrichtung',
    enableSearchFilter: true,
    enableCheckAll: false,
    limitSelection: 5,
    enableFilterSelectAll: false
};

